import Reveal from './Reveal'

const figures = [
  { value: '25+', label: 'years of software engineering' },
  { value: '4', label: 'sectors: banking, fintech, healthcare and SaaS' },
  { value: '2', label: 'public demo builds with automated tests' },
]

export default function Hero() {
  return (
    <section
      id="top"
      className="relative bg-mariner text-white pt-36 pb-40 md:pb-48 site-ledger-texture [clip-path:polygon(0_0,100%_0,100%_86%,0_100%)]"
    >
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-9">
            <Reveal>
              <p className="site-label text-vault">Software engineering consultancy · Since 1999</p>
            </Reveal>

            <Reveal delay={0.04}>
              <h1 className="site-display text-[44px] sm:text-6xl lg:text-[76px] mt-6 max-w-4xl">
                Financial-grade software, built and run by senior engineers.
              </h1>
            </Reveal>

            <Reveal delay={0.08}>
              <p className="text-lg md:text-xl text-mist leading-relaxed max-w-2xl mt-8">
                We build the systems that banks, fintechs and SaaS companies depend on every day.
                We design them, build them, and stay with them in production.
              </p>
            </Reveal>

            <Reveal delay={0.12}>
              <div className="flex flex-col sm:flex-row sm:items-center gap-6 mt-10">
                <a href="#brief" className="site-btn-primary site-focus">
                  Start a project brief
                </a>
                <a href="#work" className="site-btn-quiet site-focus text-white hover:text-vault">
                  See selected work
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="relative inline-block mt-14 -rotate-2">
                <span className="absolute inset-0 translate-x-2 translate-y-2 bg-vault rounded-sm" aria-hidden="true" />
                <p className="relative bg-parchment text-mariner font-brandSans text-base font-medium px-6 py-4 rounded-sm">
                  Brief answered within one business day.
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.16}>
          <dl className="mt-20 md:mt-24 grid grid-cols-2 lg:grid-cols-3 border-t border-ledger">
            {figures.map((f) => (
              <div key={f.label} className="flex flex-col-reverse py-6 pr-6 border-b border-ledger lg:border-b-0 lg:border-r lg:last:border-r-0 lg:pl-6 lg:first:pl-0">
                <dt className="text-sm text-mist mt-2">{f.label}</dt>
                <dd className="font-brandMono text-3xl md:text-4xl text-vault tabular-nums">{f.value}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  )
}
